<template>

    <div style="width: 100%; height: 100%;">
      <div style="width: 100%; height: 50px; line-height: 50px; font-size: 25px; font-weight: bold; background-color: #cccccc;">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 text-left">
              {{item.reference}}
            </div>
            <div class="col-md-6 text-right">
              <select class="hide-mobile" v-model="item.state" @change="updateItem">
                <option v-for="s in stateList" :value="s.value">{{s.title}}</option>
              </select>
            </div>
          </div>
        </div>


      </div>
      <div style="width: 100%; height: calc(100% - 100px); padding-top:20px; padding-bottom:20px; overflow-y: auto; padding-bottom:10px;">
        <div class="container-fluid">
          <div class="row text-left input-container">
<!--            <div class="col-12 col-md-2"></div>-->
            <div class="col-12 col-md-2">Shipper(화주명)<input type="text" class="form-control" v-model="item.requester" @change="updateItem"/></div>
<!--            <div class="col-12 col-md-2"></div>-->
            <div class="col-12 col-md-2">S/ MODE
              <select v-model="item.shippingMode" class="form-control" @change="updateItem">
                <option value="">Select</option>
                <option v-for="mode in shippingModes" :value="mode">{{mode}}</option>
              </select>
            </div>
<!--            <div class="col-12 col-md-2"></div>-->
            <div class="col-12 col-md-2">URN CODE<input type="text" class="form-control" v-model="item.urnCode" @change="updateItem"/></div>
<!--            <div class="col-12 col-md-2"></div>-->
            <div class="col-12 col-md-2">접수방식
              <select v-model="item.requestMethod" class="form-control" @change="updateItem">
                <option value="">Select</option>
                <option v-for="m in requestMethods" :value="m">{{m}}</option>
              </select>
            </div>
<!--            <div class="col-12 col-md-2"></div>-->
<!--            <div class="col-12 col-md-2">Type-->
<!--              <select v-model="item.itemType" class="form-control" @change="updateItem">-->
<!--                <option value="">Select</option>-->
<!--                <option v-for="type in itemTypeList" :value="type.value">{{type.title}}</option>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="col-12 col-md-2"></div>-->
            <div class="col-12 col-md-2">Account<input type="text" class="form-control" v-model="item.companyName" @change="updateItem"/></div>

            <div class="col-12 col-md-2">
              청구처
              <select class="form-control" v-model="item.customerId" @change="onCustomerChanged">
                <option value="0">청구처를 선택 하세요</option>
                <option v-for="c in customers" :value="c.id">{{c.title}}</option>
              </select>
            </div>

          </div>
          <hr/>
          <div class="row text-left" style="margin-top:10px;">
            <div class="col-8">
              메모
              <textarea class="form-control" rows="2" v-model="item.memo"></textarea>
            </div>
            <div class="col-4">
              택시 서비스
              <select v-model="item.taxiRequired" class="form-control">
                <option value="false">택시필요없음</option>
                <option value="true">택시서비스 필요</option>
              </select>
              정보
              <textarea v-model="item.taxiInfo" class="form-control">

              </textarea>
            </div>
          </div>
          <hr/>
          <div class="row text-left" style="margin-top:10px;">
<!--              <div class="col-12 col-md-2 text-left"></div>-->
            <div class="col-12 col-md-8">Origin Add<input type="text" class="form-control" v-model="item.addressFrom" @change="updateItem"></input></div>
<!--              <div class="col-12 col-md-2"></div>-->
            <div class="col-12 col-md-4">Tel<input type="text" class="form-control" v-model="item.phoneNumber" @change="updateItem"/></div>
          </div>
          <div class="row text-left" style="margin-top:10px;">
<!--              <div class="col-12 col-md-2 text-left"></div>-->
            <div class="col-12 col-md-8">Dest Add<input type="text" class="form-control" v-model="item.addressTo" @change="updateItem"></input></div>
<!--              <div class="col-12 col-md-2"></div>-->
            <div class="col-12 col-md-4">Tel<input type="text" class="form-control" v-model="item.destinationTel" @change="updateItem"/></div>
          </div>
          <div class="row text-left" style="margin-top: 10px;" >
            <div class="col-12 col-md-2">방문일<input type="date" class="form-control" v-model="item.visitDate" @change="updateItem"/></div>
            <div class="col-12 col-md-2">시간:
              <select  v-model="item.visitHour" class="form-control" @change="updateItem">
                <option v-for="h in 24" :value="h">{{h}}시</option>
              </select>
            </div>
            <div class="col-12 col-md-2">포장일시<input type="date" class="form-control" v-model="item.packingDate" @change="updateItem"/></div>
            <div class="col-12 col-md-2">출국일<input type="date" class="form-control" v-model="item.leavingDate" @change="updateItem"/></div>
            <div class="col-12 col-md-4">Email<input type="text" class="form-control" v-model="item.email" @change="updateItem"/></div>


          </div>

          <hr/>
          <div class="row text-left" style="margin-top:10px;">
            <div class="col-12 col-md-2" @click="getAvailableManifests">
              Manifest
              <label class="form-control">
                <span v-if="item.manifest !== undefined && item.manifest !== null && item.shippingMode === 'AIR OUT'">
                  {{item.manifest.awb}}
                </span>
                <span v-else-if="item.manifest !== undefined && item.manifest !== null">
                  {{item.manifest.bkNo}}
                </span>
                <span v-else>Not Assigned</span>
              </label>
            </div>
            <div class="col-12 col-md-2">
              M BL No
              <label class="form-control no-change">
                <span v-if="item.manifest !== undefined && item.manifest !== null">{{item.manifest.mblNo}}</span>
              </label>
            </div>
            <div class="col-12 col-md-2">
              H BL No
              <input class="form-control" v-model="item.hbNo" @change="updateItem"/>

            </div>
            <div class="col-12 col-md-2">
              Vessel Voy (Flight)
              <label class="form-control no-change">
                <span v-if="item.manifest !== undefined && item.manifest !== null">{{item.manifest.vessel}}{{item.manifest.flight}}</span>
              </label>
            </div>
            <div class="col-12 col-md-2">
              CNTR SIZE
<!--              <label class="form-control">-->
<!--                <span v-if="item.manifest !== undefined && item.manifest !== null">{{item.manifest.containerSize}}</span>-->
<!--              </label>-->
            </div>
            <div class="col-12 col-md-2">
              SEAL No
              <label class="form-control no-change">
                <span v-if="item.manifest !== undefined && item.manifest !== null">{{item.manifest.sealNumber}}</span>
              </label>
            </div>
            <div class="col-12 col-md-2">
              ETD
              <label class="form-control no-change">
                <span v-if="item.manifest !== undefined && item.manifest !== null">{{item.manifest.etd}}</span>
              </label>
            </div>
            <div class="col-12 col-md-2">
              ETA
              <label class="form-control no-change">
                <span v-if="item.manifest !== undefined && item.manifest !== null">{{item.manifest.eta}}</span>
              </label>
            </div>
          </div>
          <hr/>
          <div class="row text=left" style="margin-top:10px;">
            <div class="col-12 col-md-2">
              CBM(부피)
              <input class="form-control text-right" type="number" v-model="item.cbmFloat" @change="updateItem" :disabled="item.manifestId > 0"/>
<!--              <select class="form-control" v-model="item.cbm" @change="updateItem" :disabled="item.manifestId > 0">-->
<!--                <option v-for="(i, index) in 71" :value="index*100">{{index}} CBM</option>-->
<!--              </select>-->
<!--              <input class="form-control" type="number" v-model="item.cbm"/>-->
            </div>
            <div class="col-12 col-md-2">
              가 CBM(가부피) [{{item.manifestId}}]
              <select class="form-control" v-model="item.preCbm" @change="updateItem" :disabled="item.manifestId > 0">
                <option v-for="(i, index) in 71" :value="index">{{index}} CBM</option>
              </select>
            </div>
            <div class="col-12 col-md-2">
              KG(중량)
              <input class="form-control" type="number" v-model="item.kg" :disabled="item.manifestId > 0"/>
            </div>
            <div class="col-12 col-md-2">
              QTY(수량)
              <input class="form-control" type="number" v-model="item.qty" :disabled="item.manifestId > 0"/>
            </div>
          </div>
          <hr/>
          <div class="row text-left" style="margin-top:10px;">
            <div class="col-12 col-md-4">주차
              <select class="form-control" v-model="item.parking" @change="updateItem">
                <option v-for="parkingValue in parkingValues" :value="parkingValue.value">{{parkingValue.title}}</option>
              </select>

              작업차량 & 외주인력
              <input v-model="item.vehicles" class="form-control" @change="updateItem">
              Loading Date
              <input v-model="item.loadingDate" type="date" class="form-control" @change="updateItem">
            </div>
            <div class="col-12 col-md-4">
              주차장 사진
              <div style="width: 100%; border: 1px solid gray; text-align: center;">
                <img v-if="item.parkingImage !== null && item.parkingImage.length > 0" :src="item.parkingImage" style="width: 100%;"/>
                <div v-else>No Image</div>
              </div>
              <progress value="0" max="100" style="width: 100%;" id="uploader-parkingImage"></progress>
              <br>
              <input accept="image/*" type="file" ref="file" value="upload" @change="itemImageSelected($event, 'parkingImage', false)" data-buttonText="사진 선택">
            </div>

            <div class="col-12 col-md-4">
<!--              <div class="text-left"><strong>외주</strong></div>-->
<!--              <div style="width: 100%; display: inline-block">-->
<!--                <div v-for="(c, ai) in item.contractors"-->
<!--                     style="float:left; border: 1px solid #ccc; border-radius: 10px; padding:10px; margin-right: 10px; margin-bottom:10px; color:white; background-color: #6EC8FF">-->
<!--                  {{c}}<span style="color:red; padding-left: 20px;" v-on:click="deleteContractor(ai)"><i class="fas fa-trash"></i></span>-->
<!--                </div>-->
<!--              </div>-->
              <div style="width: 100%; display: inline-block">
                <div style="float:left; width: 200px;">
                  <input v-model="contractorNameInput" class="form-control" @change="contractorNameEntered" placeholder="외주작업자 이름"/>
                </div>
                <button style="float:left;" class="btn btn-success" @click="contractorNameEntered">Add</button>
              </div>

              특이사항
              <textarea class="form-control" v-model="item.instruction" rows="3" @change="updateItem"/>

              <button class="btn btn-primary" @click="generatePerformanceReport">Performance Report</button>
            </div>
          </div>

          <hr/>
          <div class="row hide-mobile" style="margin-top:10px;">
            <div class="col-3" >
              <div style="border: 1px solid gray; padding-bottom: 20px;">
              <div style="background-color: #3c7af4; color:white; font-size: 20px; padding:10px; font-weight: bold;"><strong>Quotations</strong></div>
              <ul class="list-group">
                <li class="list-group-item" v-for="(quotation, qi) in item.quotations" v-on:click="openInvoiceItem(quotation)"><strong>{{quotation.invoiceNumber}}</strong> #{{quotation.id}}</li>
              </ul>
              </div>
            </div>
            <div class="col-3">
              <div style="border: 1px solid gray; padding-bottom: 20px;">
                <div style="background-color: #ff6a6a; color:white; font-size: 20px; padding:10px; font-weight: bold;"><strong>INVOICE</strong></div>
                <ul class="list-group">
                  <li class="list-group-item" v-for="(invoice, ii) in item.invoices" v-on:click="openInvoiceItem(invoice)">
                    <strong>{{invoice.invoiceNumber}}</strong> #{{invoice.id}}
                    <div v-if="invoice.finalised === true" style="height: 30px; line-height: 30px; font-weight: bold;">완료</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-3">
              <div style="border: 1px solid gray; padding-bottom: 20px;">
                <div style="background-color: #1c9654; color:white; font-size: 20px; padding:10px; font-weight: bold;"><strong>Houses</strong></div>
                <ul class="list-group">
                  <li class="list-group-item" v-for="(house, ii) in item.houses" v-on:click="openHouseItem(house)">#{{house.id}}</li>
                </ul>
              </div>
            </div>
            <div class="col-3">
              <div style="border: 1px solid gray; padding-bottom: 20px;">
                <div style="background-color: #ff6a6a; color:white; font-size: 20px; padding:10px; font-weight: bold;"><strong>PACKING LIST DOC</strong></div>
                <progress value="0" max="100" :id="'uploader-packingListDoc'"></progress>
                <input accept="pdf/*, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file" ref="file" value="upload" @change="docPicked($event, 'packingListDoc')" data-buttonText="파일 선택">
                <iframe style="margin-top:10px;" v-if="item.packingListDoc !== null && item.packingListDoc.startsWith('https') && (item.packingListDoc.endsWith('pdf') || item.packingListDoc.endsWith('PDF'))"
                  :src="item.packingListDoc" width="100%"></iframe>
                <button class="btn btn-danger" v-if="item.packingListDoc !== null && item.packingListDoc.length > 0 && item.packingListDoc.endsWith('pdf')" @click="openPackingListDoc">PDF보기</button>
                <button class="btn btn-success"
                        style="margin-top:10px;"
                        v-if="item.packingListDoc !== null && item.packingListDoc.startsWith('https') && (item.packingListDoc.endsWith('xlsx') || item.packingListDoc.endsWith('XLSX'))"
                        @click="downloadExcelFile(item.packingListDoc, item.requester + '-PackingList')">
                  엑셀파일 {{item.packingListDoc.split('/')[item.packingListDoc.split('/').length - 1]}}
                </button>

<!--                <button @click="generatePackingListEx">generate Excel</button>-->
              </div>
            </div>
          </div>
          <div class="row" >
            <div class="col-12 text-left" >
              <div style="border-top: 1px solid #b2b2b2; margin-top: 20px; font-size: 20px; padding-top: 10px;">
              <strong>Documents</strong>
              </div>
            </div>


            <div class="col-2">
              <div style="border: 1px solid gray; padding-bottom: 5px;">
                <div style="font-size: 20px; padding:10px; font-weight: bold;" :class="{'file-available': item.packingInvoiceItem !== null}"><strong>Packing Invoice</strong></div>
                <div>
                  <button v-if="item.packingInvoiceItem !== null" @click="openPackingInvoiceItem(item.packingInvoiceItem)" class="open-btn">Open</button>
                  <button v-else @click="createPackingInvoiceItem">Create</button>
<!--                  <input type="file" ref="packingInvoiceFile" style="display: none;" @change="onDocumentSelected($event, 'packingInvoice')"/>-->
<!--                  <button @click="onDocumentUploadClicked('packingInvoice')" class="upload-btn">Upload</button>-->
                </div>
              </div>
            </div>
            <div class="col-2">
              <div style="border: 1px solid gray; padding-bottom: 5px;">
                <div style="font-size: 20px; padding:10px; font-weight: bold;" :class="{'file-available': item.approvalLetter !== null && item.approvalLetter.length > 0}"><strong>Approval Letter</strong></div>
                <div>
                  <button v-if="item.approvalLetter !== null && item.approvalLetter.length > 0" @click="openDocument(item.approvalLetter)" class="open-btn">Open</button>
                  <input type="file" ref="approvalLetterFile" style="display: none;" @change="onDocumentSelected($event, 'approvalLetter')"/>
                  <button @click="onDocumentUploadClicked('approvalLetter')" class="upload-btn">Upload</button>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div style="border: 1px solid gray; padding-bottom: 5px;">
                <div style="font-size: 20px; padding:10px; font-weight: bold;" :class="{'file-available': item.psid !== null && item.psid.length > 0}"><strong>P.S ID</strong></div>
                <div>
                  <button v-if="item.psid !== null && item.psid.length > 0" @click="openDocument(item.psid)" class="open-btn">Open</button>
                  <input type="file" ref="psidFile" style="display: none;" @change="onDocumentSelected($event, 'psid')"/>
                  <button @click="onDocumentUploadClicked('psid')" class="upload-btn">Upload</button>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div style="border: 1px solid gray; padding-bottom: 5px;">
                <div style="font-size: 20px; padding:10px; font-weight: bold;" :class="{'file-available': item.commercialInvoice !== null && item.commercialInvoice.length > 0}"><strong>Commercial Invoice</strong></div>
                <div>
                  <button v-if="item.commercialInvoice !== null && item.commercialInvoice.length > 0" @click="openDocument(item.commercialInvoice)" class="open-btn">Open</button>
                  <input type="file" ref="commercialInvoiceFile" style="display: none;" @change="onDocumentSelected($event, 'commercialInvoice')"/>
                  <button @click="onDocumentUploadClicked('commercialInvoice')" class="upload-btn">Upload</button>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div style="border: 1px solid gray; padding-bottom: 5px;">
                <div style="font-size: 20px; padding:10px; font-weight: bold;" :class="{'file-available': item.tncAgreement !== null && item.tncAgreement.length > 0}"><strong>개인정보 동의서</strong></div>
                <div>
                  <button v-if="item.tncAgreement !== null && item.tncAgreement.length > 0" @click="openDocument(item.tncAgreement)" class="open-btn">Open</button>
                  <input type="file" ref="tncAgreementFile" style="display: none;" @change="onDocumentSelected($event, 'tncAgreement')"/>
                  <button @click="onDocumentUploadClicked('tncAgreement')" class="upload-btn">Upload</button>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div style="border: 1px solid gray; padding-bottom: 5px;">
                <div style="font-size: 20px; padding:10px; font-weight: bold;" :class="{'file-available': item.reasonStatement !== null && item.reasonStatement.length > 0}"><strong>반입 사유서</strong></div>
                <div>
                  <button v-if="item.reasonStatement !== null && item.reasonStatement.length > 0" @click="openDocument(item.reasonStatement)" class="open-btn">Open</button>
                  <input type="file" ref="reasonStatementFile" style="display: none;" @change="onDocumentSelected($event, 'reasonStatement')"/>
                  <button @click="onDocumentUploadClicked('reasonStatement')" class="upload-btn">Upload</button>
                </div>
              </div>
            </div>
            <div class="col-10"></div>
            <div class="col-2">
              <div style="border: 1px solid gray; padding-bottom: 5px; background: #006FB9; color: white; font-weight: bold; cursor: pointer;">
                <div style="font-size: 20px; padding:10px; font-weight: bold;" @click="generatePerformanceReport"><strong>Performance Report</strong></div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="margin-top:20px; ">
              <div style="border: 1px solid black; padding-bottom:20px;">
                <div style="background-color: #537799; color:white; font-size: 20px; padding:10px; font-weight: bold;"><strong>Credits</strong></div>
                <table class="table">
                  <tr>
                    <th>Date</th>
                    <th>거래처</th>
                    <th>내용</th>
                    <th>Amount</th>
                    <th>Tax</th>
                    <th>Total</th>
                    <th></th>
                  </tr>
                  <tbody>
                  <tr v-for="(credit, ci) in item.credits">
                    <td>
                      <input type="date" v-model="credit.invoiceDate" class="form-control" :disabled="credit.edit === false"/>
                    </td>
                    <td>
                      <select v-model="credit.customerId" class="form-control" :disabled="credit.edit === false">
                        <option value="0">Select</option>
                        <option v-for="c in customers" :value="c.id">{{c.title}}</option>
                      </select>
                    </td>
                    <td>
                      <input v-model="credit.description" class="form-control" :disabled="credit.edit === false"></input>
                    </td>
                    <td>
                      <input type="number" v-model="credit.amountFloat" class="form-control" :disabled="credit.edit === false" @change="onCreditMoneyChanged(ci)"></input>
                    </td>
                    <td>
                      <input type="number" v-model="credit.vatFloat" class="form-control" :disabled="credit.edit === false" @change="onCreditMoneyChanged(ci)"></input>
                    </td>
                    <td>
                      <strong>{{(credit.total/100.0).toFixed(2)}}</strong>
                    </td>
                    <td>
                      <button v-if="credit.edit === false" class="btn btn-success" @click="credit.edit = true"><i class="fas fa-edit"></i></button>
                      <button v-if="credit.edit === false" class="btn btn-danger" @click="deleteCredit(ci)"><i class="fas fa-trash"></i></button>
                      <button v-if="credit.edit === true" class="btn btn-danger" @click="cancelCreditEdit(ci)"><i class="fas fa-ban"></i></button>
                      <button v-if="credit.edit === true" class="btn btn-primary" @click="saveCredit(ci)"><i class="fas fa-save"></i></button>
                    </td>
                  </tr>
                  </tbody>

                </table>
                <div class="text-left">
                  <button class="btn btn-primary" style="margin-left:15px;" @click="addCredit"><i class="fas fa-plus"></i> Credit 항목 추가하기</button>
                </div>
              </div>
            </div>

          </div>


          <hr/>
<!--          <div class="row" v-if="item.id > 0">-->
<!--            <div class="col-12">-->
<!--              <div class="card-header">-->
<!--                <strong>Room List</strong>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-6 col-md-3" v-for="location in locationList">-->
<!--              <div style="padding:10px; border: 1px solid gray; margin-bottom: 5px; border-radius: 10px;" v-on:click="openLocationItems(location)">-->
<!--              {{location.title}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="row">

            <div class="col-12" v-if="item.id > 0">
              <div class="card">
                <div class="card-header">
                  품목리스트
                </div>
                <div class="card-body" style="padding-left: 0; padding-right: 0; padding-top: 0;">

                  <div class="row">
                    <template v-for="(good, gi) in item.items">
                      <div class="col-6 col-md-4 col-lg-3" style="margin-bottom: 20px; border-bottom: 1px solid gray; padding-bottom: 10px;">
                        <template v-if="good.imageUrl !== null && good.imageUrl.length > 0">
                          <img :src="good.imageUrlSmall" style="width: 100%;" class="show-mobile"/>
                          <img :src="good.imageUrl" style="width: 100%;" class="hide-mobile"/>
                          <textarea v-model="good.description" class="form-control" style="margin-top:5px;" placeholder="MEMO" rows="3" v-on:change="updateGoodItem(gi)"/>
                        </template>
                        <template v-else>
                          <div style="width: 100%; min-height: 38px; line-height: 38px; background-color: #BBEAFF; font-weight: bold;" v-on:click="editGoodItem = good">
                            {{good.title}}
                          </div>
                          <div style="width: 100%; min-height: 38px; display: flex;">
                            <div style="width: calc(100% - 50px); padding:5px; text-align: left;">
                              <strong>준비물:</strong>
                              <div style="width: 100%; display: inline-block;">
                                <div v-for="pre in item.preparations" v-if="pre.parentId === good.id" style="float: left; padding: 5px; border-radius: 5px; border: 1px solid gray;">
                                  {{pre.title}} x {{pre.amount}}
                                </div>
                              </div>
                            </div>
                            <div style="width: 50px;padding-top:5px;">
                              <strong>CBM:</strong><br/>
                              <select v-model="good.volume" v-on:change="updateGoodItem(gi)">
                                <option v-for="i in 20" :value="i*0.5">{{i*0.5}}</option>
                              </select>
                            </div>

                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div class="row">
                    <div class="col-12" style="height: 50px;">
                      <progress value="0" max="100" id="uploader-add"></progress>
                      <input accept="image/*" type="file" ref="file" value="upload" @change="takePhotoToAdd" data-buttonText="사진 선택">
                    </div>
                  </div>
<!--                  <div class="show-mobile" style="display: none;">-->
<!--                    <ul class="list-group">-->
<!--                      <li class="list-group-item text-left" style="padding:0; margin-bottom: 5px; border: 1px solid black;" v-for="(good, ii) in item.items">-->
<!--                        <div style="width: 100%; min-height: 38px; display: flex;" >-->
<!--                          <div style="width: 100%; min-height: 38px; line-height: 38px; padding:5px;"  v-on:click="openEditGoodItem(good.id)">-->
<!--                            <div class="thumbnail-container" style="float: left;">-->
<!--                              <img style="width:calc(100% - 10px);" v-if="good.imageUrl != null && good.imageUrl.length > 0" :src="good.imageUrl"/>-->
<!--                            </div>-->
<!--                            [{{good.location}}] <strong>{{good.title}}</strong>  <span v-if="good.removal === true" style="color:red;"><i class="fas fa-trash"></i></span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div style="width: 100%; min-height: 38px; display: flex; background-color: #EAEAEA;" >-->
<!--                          <div style="width: calc(100% - 50px); padding:5px;">-->
<!--                            <strong>준비물:</strong>-->
<!--                            <div style="width: 100%; display: inline-block;">-->
<!--                              <div v-for="pre in item.preparations" v-if="pre.parentId === good.id" style="float: left; padding: 5px; border-radius: 5px; border: 1px solid gray;">-->
<!--                                {{pre.title}} x {{pre.amount}}-->
<!--                              </div>-->
<!--                            </div>-->
<!--&lt;!&ndash;                            <select v-model="good.amount" v-on:change="updateGoodItem(ii)">&ndash;&gt;-->
<!--&lt;!&ndash;                              <option v-for="(i, ii) in 20" :value="ii">{{ii}}개</option>&ndash;&gt;-->
<!--&lt;!&ndash;                            </select>&ndash;&gt;-->
<!--                          </div>-->
<!--                          <div style="width: 50px;padding-top:5px;">-->
<!--                            <strong>CBM:</strong><br/>-->
<!--                            <select v-model="good.volume" v-on:change="updateGoodItem(ii)">-->
<!--                              <option v-for="i in 20" :value="i*0.5">{{i*0.5}}</option>-->
<!--                            </select>-->
<!--                          </div>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <button class="btn btn-danger" style="float: right;" v-on:click.stop="deleteGoodItem(ii)"><i class="fas fa-trash"></i></button>&ndash;&gt;-->




<!--                      </li>-->
<!--                    </ul>-->
<!--                    <div style="width: 100%; padding:5px; text-align: right">-->
<!--                      <button class="btn btn-success" v-on:click="addGoodItem"><i class="fas fa-plus-circle"></i> 항목추가</button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <table class="table hide-mobile" style="display: none;">-->
<!--                    <tr>-->
<!--                      <th class="thumbnail-container">사진</th>-->
<!--                      <th class="text-left">품명</th>-->
<!--                      <th>위치</th>-->
<!--                      <th>준비물</th>-->
<!--                      <th>CBM</th>-->
<!--                      <th></th>-->
<!--                      <th></th>-->
<!--                    </tr>-->
<!--                    <tr v-for="(good, ii) in item.items">-->
<!--                      <td class="thumbnail-container">-->
<!--                        <img style="width:100%;" v-if="good.imageUrl != null && good.imageUrl.length > 0" :src="good.imageUrl"/>-->
<!--                      </td>-->
<!--                      <td class="text-left"><input type="text" class="form-control" v-model="good.title" @change="updateGoodItem(ii)"/></td>-->
<!--                      <td>-->
<!--                        <select v-model="good.location" class="form-control" @change="updateGoodItem(ii)">-->
<!--                          <option v-for="loc in locationList" :value="loc.title">{{loc.title}}</option>-->
<!--                        </select>-->

<!--                      </td>-->
<!--                      <td style="min-width: 300px;">-->
<!--                        <div style="width: 100%; display: inline-block;">-->
<!--                          <div v-for="pre in item.preparations" v-if="pre.parentId === good.id" style="float: left; padding: 5px; border-radius: 5px; border: 1px solid gray;">-->
<!--                            {{pre.title}} x {{pre.amount}}-->
<!--                          </div>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <select v-model="good.amount" class="form-control" @change="updateGoodItem(ii)">&ndash;&gt;-->
<!--&lt;!&ndash;                          <option v-for="(i, ii) in 20" :value="ii">{{ii}}</option>&ndash;&gt;-->
<!--&lt;!&ndash;                        </select>&ndash;&gt;-->
<!--                      </td>-->
<!--                      <td>-->
<!--                        <select v-model="good.volume" class="form-control" @change="updateGoodItem(ii)">-->
<!--                          <option v-for="i in 20" :value="i*0.5">{{i*0.5}}</option>-->
<!--                        </select>-->
<!--&lt;!&ndash;                        <select v-model="good.size" class="form-control" @change="updateGoodItem(ii)" :disabled="true">&ndash;&gt;-->
<!--&lt;!&ndash;                          <option v-for="s in goodSizeList" :value="s.title">{{s.title}}</option>&ndash;&gt;-->
<!--&lt;!&ndash;                        </select>&ndash;&gt;-->
<!--                      </td>-->
<!--                      <td>-->
<!--&lt;!&ndash;                        <i v-if="good.imageUrl !== null && good.imageUrl.length > 0" class="fas fa-image"></i>&ndash;&gt;-->
<!--                        <button class="btn btn-success"><i class="fas fa-edit" v-on:click="openEditGoodItem(good.id)"></i></button>-->
<!--                      </td>-->
<!--                      <td>-->
<!--                        <button class="btn btn-danger" v-on:click="deleteGoodItem(ii)"><i class="fas fa-trash"></i></button>-->
<!--                      </td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td class="text-left" colspan="7">-->
<!--                        <button class="btn btn-success" v-on:click="addGoodItem"><i class="fas fa-plus-circle"></i> 항목추가</button>-->
<!--                      </td>-->
<!--                    </tr>-->
<!--                  </table>-->
                </div>
                <div class="card-footer text-right">
                  견적: £ <input type="number" v-model="item.estimatedPrice" style="width:100px; height: 38px;" @change="updateItem"/>
                </div>
              </div>
              <!--                <div style="font-size: 15px; font-weight: bold; text-align: left;">품목리스트</div>-->

              <!--                <div class="row">-->
              <!--                  <div class="col-2">-->
              <!--                    -->
              <!--                  </div>-->
              <!--                  <div class="col-4">-->
              <!--                    -->
              <!--                  </div>-->
              <!--                </div>-->
            </div>
            <div class="col-12 hide-mobile" style="margin-top:20px;" v-if="item.id > 0">
              <div class="card">
                <div class="card-header">
                  Assignment
                </div>
                <div class="card-body">


                  <hr/>
                  <div class="text-left"><strong>담당</strong></div>

                  <div style="width: 100%; display: inline-block">
                    <div v-for="(assignee, ai) in item.assignees"
                         style="float:left; border: 1px solid #ccc; border-radius: 10px; padding:10px; margin-right: 10px; margin-bottom:10px; color:white; background-color: #6EC8FF">
                      {{assignee.user.name}} {{assignee.user.email}} <span style="color:red; padding-left: 20px;" v-on:click="deleteAssignee(ai)"><i class="fas fa-trash"></i></span>
                    </div>
                  </div>

                  <div class="text-left" style="margin-top:10px;">Select from Staff List to assign</div>
                  <div style="width: 100%; display: inline-block;">
                    <div v-for="staff in staffList"
                         style="float:left; border: 1px solid #ccc; border-radius: 10px; padding:10px; margin-right: 10px; margin-bottom:10px; color:gray;"
                         v-if="isUserAssigned(staff) == false"
                         v-on:click="assignStaff(staff)"
                    >{{staff.name}} {{staff.email}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" style="margin-top: 20px;" v-if="item.id > 0">
              <div class="card">
                <div class="card-header">
                  준비물 리스트
                </div>
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item" v-for="p in preparationList">
                      {{p.title}} x {{getPreparationItemCount(p)}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-12" style="margin-top:20px; display: none;" v-if="item.id > 0">
              <div class="card">
                <div class="card-header">
                  공통 준비물
                </div>
                <div class="card-body" style="padding: 0;">
                  <table class="table">
                    <tr>
                      <th class="text-left">품명</th>
                      <th>수량</th>
                      <th></th>
                    </tr>
                    <tr v-for="(good, ii) in item.preparations" v-if="good.parentId === 0">
                      <td class="text-left"><input type="text" class="form-control" v-model="good.title" @change="updatePreparationItem(ii)"/></td>

                      <td>
                        <select v-if="good.min >= 1 && good.max > good.min" v-model="good.amount" class="form-control" @change="updatePreparationItem(ii)">
                          <option v-for="i in good.max/good.gap" v-if="i*good.gap >= good.min" :value="i*good.gap">{{i*good.gap}}</option>
                        </select>
                        <input v-else v-model="good.amount" class="form-control"  @change="updatePreparationItem(ii)"/>
                      </td>
                      <td>
                        <button class="btn btn-danger" v-on:click="deletePreparationItem(ii)"><i class="fas fa-trash"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left" colspan="4">
                        <button class="btn btn-success" v-on:click="addPreparationItem"><i class="fas fa-plus-circle"></i> 항목추가</button>
                      </td>
                    </tr>
                  </table>
                  <div>기본 준비물 (팔요한 항목들 선택하여 수량 입력)</div>
                  <div style="width: 100%; display: inline-block; border-radius: 10px; padding:10px; background-color: #F4F4F4;">
                    <div style="float: left; padding: 10px; border-radius: 10px; border: 1px solid grey; margin-left: 10px; margin-bottom: 10px;" v-for="p in preparationList" v-if="showPreparationItem(p) == true" v-on:click="onClickPreparationList(p)">{{p.title}}</div>
                  </div>
                </div>
              </div>

              <!--                <div style="font-size: 15px; font-weight: bold; text-align: left;">준비물</div>-->

            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid" style="width: 100%; height: 50px; background-color: #E8E8E8;">
        <div class="row">
          <div class="col-3 text-left" style="height: 50px; line-height: 50px;">
            <button class="btn btn-dark" v-on:click="closeItem">Close</button>
            <button class="btn btn-danger" style="margin-left: 20px;" @click="cloneItem">복사하기</button>

          </div>
          <div class="col-9 text-right" style="height: 50px; line-height: 50px;">

            <template v-if="item.id > 0">
              <button  class="btn btn-danger" @click="deleteItem">DELETE</button>
            <button class="btn btn-success hide-mobile" v-on:click="openSurveyForm">Survey Form
              <span v-if="item.surveyForm !== null && item.surveyForm.length">보기</span>
              <span v-else>생성</span>
            </button>
            <button class="btn btn-danger hide-mobile" v-on:click="openEmailItem">문서보내기</button>
<!--            <button class="btn btn-success hide-mobile" v-on:click="sendEmailForm">Form 보내기</button>-->
              <button class="btn btn-success hide-mobile" v-if="item.shippingMode === 'SEA OUT' || item.shippingMode === 'AIR IN' || item.shippingMode === 'SEA IN'" v-on:click="sendEmailForm">Status Email 보내기</button>

              <button class="btn btn-primary hide-mobile" v-on:click="createInvoice('quotation')">QUOTATION 생성</button>
              <button class="btn btn-success hide-mobile" v-on:click="createInvoice('invoice')">INVOICE 생성</button>
              <button class="btn btn-success hide-mobile" v-on:click="createHouse()">HOUSE 생성</button>
              <button  class="btn btn-primary" @click="updateItem(true)">SAVE</button>

              <button class="btn btn-dark hide-mobile" @click="completeItem()">완료처리하기</button>
            </template>
            <button v-if="item.id == 0" class="btn btn-primary" @click="createItem">CREATE</button>
          </div>
        </div>
      </div>
<!--      <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="emailItem != false"  v-on:click="emailItem = false">-->
<!--        <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); height: 90%; transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">-->
<!--          <div style="height: 50px; width:100%; line-height: 50px; font-weight: bold; font-size: 30px;">-->
<!--            {{item.reference}} 이메일 보내기-->
<!--          </div>-->
<!--          <div class="container text-left" style="height: calc(100% - 100px); overflow-y: auto;">-->
<!--            <div class="row">-->
<!--              <div class="col-12">고객: {{item.requester}}</div>-->
<!--              <div class="col-12">Email (2명이상이면 ,(콤마)로 구분)-->
<!--                <input v-model="emailItem.to" class="form-control"/>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-12" style="margin-top:20px;">-->
<!--                이메일 제목:-->
<!--                <input class="form-control" v-model="emailItem.subject"/>-->
<!--              </div>-->
<!--              <div class="col-12" style="margin-top:20px;">-->
<!--                이메일 내용:-->
<!--                <textarea class="form-control" v-model="emailItem.body" rows="5"/>-->
<!--              </div>-->
<!--              <div class="col-12" style="margin-top:20px;">-->
<!--                첨부문서-->
<!--                <div style="width: 100%; padding:10px; display: inline-block; border-radius: 10px; border: 1px solid grey;">-->
<!--                  <div style="padding:5px; border: 1px solid grey; float:left; margin-right:10px;" v-for="(doc, di) in emailItem.documents">{{doc.title}} <span v-on:click="removeEmailDocItem(di)"><i class="fas fa-trash"></i></span></div>-->
<!--                </div>-->

<!--                문서리스트 (첨부할 문서를 선택해주세요)-->
<!--                <div style="width: 100%; padding:10px; display: inline-block; border-radius: 10px; border: 1px solid grey;">-->
<!--                  <div style="padding:5px; border: 1px solid grey; float:left; margin-right:10px;" v-for="(doc, di) in documents" v-on:click="addEmailDocItem(doc)">{{doc.title}}</div>-->
<!--                </div>-->
<!--              </div>-->


<!--            </div>-->
<!--          </div>-->
<!--          <div class="container" style="height: 50px; width: 100%; line-height: 50px;">-->
<!--            <div class="row">-->
<!--              <div class="col-3 text-left">-->
<!--                <button class="btn btn-dark" v-on:click="emailItem = false">Close</button>-->
<!--              </div>-->
<!--              <div class="col-9 text-right">-->
<!--                <button class="btn btn-success" @click="sendEmailToCustomer">Send</button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div v-if="locationItem != false" style="position: fixed; top:0; left:0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); z-index: 2;" v-on:click="locationItem = false">
        <div style="position: absolute; top: 50%; left: 50%; width: 90%; max-width: 500px; height: 90%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; overflow:hidden; box-shadow: 3px 3px 5px black;"
             v-on:click.stop="dummy">
          <div class="container" style="padding-top:0;padding-bottom: 0; background-color: #E5E5E5; font-weight: bold;">
            <div class="row">
              <div class="col-12" style="height: 50px; line-height: 50px;"><strong>{{locationItem.location.title}}</strong></div>
            </div>


          </div>

          <div class="container" style="height: calc(100% - 170px); overflow-y: auto; padding-top:10px; padding-bottom: 10px;" id="location-item-list-container">
            <div class="row">

              <template v-for="(good, gi) in item.items">
                <div class="col-6"  v-if="good.location === locationItem.location.title" style="padding-bottom:10px; border-bottom:1px solid gray; margin-bottom: 10px;">
                  <template v-if="good.imageUrl !== null && good.imageUrl.length > 0">
                    <img :src="good.imageUrlSmall" style="width: 100%;"/>
                    <textarea v-model="good.description" class="form-control" style="margin-top:5px;" placeholder="MEMO" rows="3" v-on:change="updateGoodItem(gi)"/>
                  </template>
                  <template v-else>
                    <div style="width: 100%; min-height: 38px; line-height: 38px; background-color: #BBEAFF; font-weight: bold;" v-on:click="editGoodItem = good">
                      {{good.title}}
                    </div>
                    <div style="width: 100%; min-height: 38px; display: flex;">
                      <div style="width: calc(100% - 50px); padding:5px; text-align: left;">
                        <strong>준비물:</strong>
                        <div style="width: 100%; display: inline-block;">
                          <div v-for="pre in item.preparations" v-if="pre.parentId === good.id" style="float: left; padding: 5px; border-radius: 5px; border: 1px solid gray;">
                            {{pre.title}} x {{pre.amount}}
                          </div>
                        </div>
                      </div>
                      <div style="width: 50px;padding-top:5px;">
                        <strong>CBM:</strong><br/>
                        <select v-model="good.volume" v-on:change="updateGoodItem(gi)">
                          <option v-for="i in 20" :value="i*0.5">{{i*0.5}}</option>
                        </select>
                      </div>

                    </div>
                  </template>
                </div>
              </template>
              <div class="col-12" style="display: none;">
                <ul class="list-group">
                  <li class="list-group-item" style="padding:0; margin-bottom: 5px; border: 1px solid black;" v-for="(good, gi) in item.items" v-if="good.location === locationItem.location.title">

                    <template v-for="(good, gi) in item.items">
                      <div class="col-6"  v-if="good.location === locationItem.location.title">
                        <template v-if="good.imageUrl !== null && good.imageUrl.length > 0">
                          <img :src="good.imageUrlSmall" style="width: 100%;"/>
                        </template>
                        <template v-else>
                          <div style="width: 100%; min-height: 38px; line-height: 38px; background-color: #BBEAFF; font-weight: bold;" v-on:click="editGoodItem = good">
                            {{good.title}}
                          </div>
                          <div style="width: 100%; min-height: 38px; display: flex;">
                            <div style="width: calc(100% - 50px); padding:5px; text-align: left;">
                              <strong>준비물:</strong>
                              <div style="width: 100%; display: inline-block;">
                                <div v-for="pre in item.preparations" v-if="pre.parentId === good.id" style="float: left; padding: 5px; border-radius: 5px; border: 1px solid gray;">
                                  {{pre.title}} x {{pre.amount}}
                                </div>
                              </div>
                            </div>
                            <div style="width: 50px;padding-top:5px;">
                              <strong>CBM:</strong><br/>
                              <select v-model="good.volume" v-on:change="updateGoodItem(gi)">
                                <option v-for="i in 20" :value="i*0.5">{{i*0.5}}</option>
                              </select>
                            </div>

                          </div>
                        </template>
                      </div>
                    </template>
<!--                    <div style="width: 100%; min-height: 38px; line-height: 38px; background-color: #BBEAFF; font-weight: bold;" v-on:click="editGoodItem = good">-->
<!--                      {{good.title}}-->
<!--                    </div>-->
<!--                    <div style="width: 100%; min-height: 38px; display: flex;">-->
<!--                      <div style="width: calc(100% - 50px); padding:5px; text-align: left;">-->
<!--                        <strong>준비물:</strong>-->
<!--                        <div style="width: 100%; display: inline-block;">-->
<!--                          <div v-for="pre in item.preparations" v-if="pre.parentId === good.id" style="float: left; padding: 5px; border-radius: 5px; border: 1px solid gray;">-->
<!--                            {{pre.title}} x {{pre.amount}}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div style="width: 50px;padding-top:5px;">-->
<!--                        <strong>CBM:</strong><br/>-->
<!--                        <select v-model="good.volume" v-on:change="updateGoodItem(gi)">-->
<!--                          <option v-for="i in 20" :value="i*0.5">{{i*0.5}}</option>-->
<!--                        </select>-->
<!--                      </div>-->

<!--                    </div>-->


                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="container" style="height: 150px; overflow-y: auto; display: none;">
            <div class="row">
              <div class="col-12">
                아래에서 선택하세요
                <div style="display: inline-block; padding:0;">
                  <template v-if="locationItem.location.tags !== null && locationItem.location.tags.length > 0">
                    <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="tag in locationItem.location.tags" v-on:click="addLocationGood(tag)">{{tag}}</div>
                  </template>
                  <template v-else>
                    <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="(ex, ei) in goodExamples" v-on:click="addLocationGood(ex.title)">{{ex.title}}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="content" style="height: 70px; padding-bottom: 20px;">
            <div class="row">
              <div class="col-12" style="height: 50px;">
                <progress value="0" max="100" id="uploader-add"></progress>
                <input accept="image/*" type="file" ref="file" value="upload" @change="takePhotoToAdd" data-buttonText="사진 선택">
              </div>
            </div>
<!--            <div class="row">-->
<!--              <div class="col-12">-->
<!--                <button class="btn btn-primary form-control" v-on:click="takePhotoToAdd">사진촬영</button>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="container" style="height: 50px; display:none;">
            <div class="row">
              <div class="col-9" style="padding-right: 0; height: 50px;">
                <input type="text" v-model="locationItem.newItemTitle" class="form-control"/>
              </div>
              <div class="col-3" style="padding-left: 0; height: 50px;">
                <button class="btn btn-success form-control" v-on:click="addLocationGoodManually">Add</button>
              </div>
            </div>
          </div>
          <div class="container" style="height: 50px;">
            <div class="row">
              <div class="col-12">
                <button class="btn btn-dark form-control" @click="locationItem = false">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="editGoodItem != false" style="position: fixed; top:0; left:0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); z-index: 3;" v-on:click="editGoodItem = false">
        <div style="position: absolute; top: 50%; left: 50%; width: 90%; max-width: 500px; height: 90%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; overflow:hidden; box-shadow: 3px 3px 5px black;"
             v-on:click.stop="dummy">
          <div class="container" style="padding-top:0;padding-bottom: 0; background-color: #E5E5E5; font-weight: bold;">
            <div class="row">
              <div class="col-12"><span v-if="editGoodItem.id == 0">물품 추가</span><span v-else>물품 수정</span></div>
            </div>

          </div>
          <div class="container" style="height: calc(100% - 70px); overflow-y: auto;">
            <div class="row">
              <!--            <div class="col-12" style="font-weight: bold;">-->
              <!--            -->
              <!--            </div>-->
              <div class="col-12">
                <span style="font-weight: bold;">위치</span>

                <input type="text" v-model="editGoodItem.location" class="form-control" placeholder="직접입력"/>
              </div>
            </div>
            <hr/>
            <div class="row" v-if="editGoodItem.id > 0">
              <div class="col-12" style="font-weight: bold;">
                사진
                <img v-if="editGoodItem.imageUrl != null && editGoodItem.imageUrl.length > 0" :src="editGoodItem.imageUrl" style="width: 100%;"/>
              </div>
              <div class="col-12">
                <progress value="0" max="100" id="uploader"></progress>
                <input accept="image/*" type="file" ref="file" value="upload" @change="imageSelected" data-buttonText="사진 선택">
              </div>
            </div>
            <hr/>
            <div class="row">
              <!--            <div class="col-12" style="font-weight: bold;">-->
              <!--            품명-->
              <!--            </div>-->
              <div class="col-12">
                <span style="font-weight: bold;">품명</span>
                <input type="text" v-model="editGoodItem.title" class="form-control" placeholder="직접입력"/>
              </div>
              <div class="col-12">
                아래에서 선택하세요
                <div style="display: inline-block; padding:0;">
                  <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="(ex, ei) in goodExamples" v-on:click="editGoodItem.title = ex.title">{{ex.title}}</div>
                </div>
              </div>
            </div>
            <hr/>

            <div class="row">
              <div class="col-12">
                <div><strong>기본 준비물</strong></div>
              </div>
              <div class="col-12">
                <ul class="list-group">
                  <li class="list-group-item" style="padding:5px;" v-for="(prep, pi) in item.preparations" v-if="prep.parentId === editGoodItem.id">
                    <div style="width: 100%; display: flex;">
                      <div style="width: calc(100% - 100px);" class="text-left">
                        {{prep.title}}
                      </div>
                      <select v-if="prep.min >= 1 && prep.max > prep.min" v-model="prep.amount" style="width: 50px;"@change="updatePreparationItem(pi)">
                        <option v-for="i in prep.max/prep.gap" v-if="i*prep.gap >= prep.min" :value="i*prep.gap">{{i*prep.gap}}</option>
                      </select>
                      <input v-else v-model="prep.amount" style="width: 50px;"  @change="updatePreparationItem(pi)"/>
<!--                      <input v-model="prep.amount" style="width: 50px;" @change="updatePreparationItem(pi)"/>-->
                      <div style="width: 50px; height: 30px; line-height: 30px; "  v-on:click="deletePreparationItem(pi)">
                        <span><i class="fas fa-trash"></i></span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12" style="padding-top: 10px;">
                (팔요한 항목들 선택하여 수량 입력)
                <div style="display: inline-block; padding:0;">
                  <div style="width: 100%; display: inline-block; border-radius: 10px; background-color: #F4F4F4;">
                    <div style="float: left; padding: 5px; border-radius: 5px; border: 1px solid grey; margin-right: 5px; margin-bottom: 5px;" v-for="p in preparationList" v-if="showPreparationItem(p) == true" v-on:click="onClickPreparationList(p, editGoodItem.id)">{{p.title}}</div>
                  </div>
<!--                  <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="(loc, li) in locationList" v-on:click="editGoodItem.location = loc.title">{{loc.title}}</div>-->
                </div>
              </div>
            </div>
            <hr/>
            <div class="row">
              <!--            <div class="col-12" >-->

              <!--            </div>-->
<!--              <div class="col-12 text-left">-->
<!--                <span style="font-weight: bold;">박스 수</span>-->
<!--                <select type="text" v-model="editGoodItem.amount" class="form-control" placeholder="직접입력">-->
<!--                  <option v-for="i in 20" :value="i">{{i}}개</option>-->
<!--                </select>-->
<!--              </div>-->
              <div class="col-12 text-left">
                <span style="font-weight: bold;">CBM</span>
                <select type="text" v-model="editGoodItem.volume" class="form-control" placeholder="직접입력">
                  <option v-for="i in 20" :value="i*0.5">{{i*0.5}}</option>
                </select>
              </div>
<!--              <div class="col-12">-->
<!--                아래에서 선택하세요-->
<!--                <div style="display: inline-block; padding:0;">-->
<!--                  <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="(size, li) in sizeList" v-on:click="editGoodItem.size = size.title">{{size.title}}</div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
            <div class="row" style="padding-bottom: 20px;">
              <div class="col-12 text-left">
                <span style="font-weight: bold;">분류</span>
                <select v-model="editGoodItem.removal" class="form-control">
                  <option value="false">이사품목</option>
                  <option value="true">버릴품목</option>
                </select>
              </div>
            </div>

          </div>
          <div class="container" style="padding-top:0;padding-bottom: 0; height: 46px; padding-top:6px;">
            <div class="row">
              <div class="col-4">
                <button class="btn btn-danger form-control" @click="deleteEditGoodItem">지우기</button>
              </div>
              <div class="col-4">
                <button class="btn btn-dark form-control" @click="editGoodItem = false">닫기</button>
              </div>
              <div class="col-4">
                <button class="btn btn-success form-control" @click="updateEditGoodItem">완료</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="position: fixed; width: 100%; height: 100%; top:0; left: 0; background-color: rgba(0,0,0,0.6);" v-if="manifestCandidates !== null && manifestCandidates.length > 0" @click="manifestCandidates = null">
        <div style="position: absolute; top:50%; left:50%; transform: translate(-50%, -50%); width: 500px; height: 70%; background-color: white; border-radius: 10px; padding: 10px;">
          <div style="width: 100%; height: 50px; line-height: 50px; font-weight: bold; font-size: 20px;">
            Manifest List
          </div>
          <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto;">
            <ul class="list-group">
              <li class="list-group-item" v-for="manifest in manifestCandidates" v-on:click="selectManifest(manifest)">
                <div><strong>{{manifest.shippingMode}}</strong> <br/>MBL: {{manifest.mblNo}} <br/>BK No: {{manifest.bkNo}} <br/>ETD: {{manifest.etd}} ETA: ETD: {{manifest.eta}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="invoiceItem != false" @click="invoiceItem = false">
        <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1500px; height: 90%; transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">

        <InvoiceView v-if="invoiceItem !== false"
                     :item="invoiceItem"
                     :request="item"
                     :customers="customers"
                     :on-updated="onInvoiceItemUpdated"
                     :on-close="onInvoiceItemClosed"
                     :on-deleted="onInvoiceItemDeleted"
                      :create-invoice="createInvoiceFromQuotation"/>
        </div>
      </div>


      <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="houseItem != false" @click="houseItem = false">
        <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1500px; height: 90%; transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">

          <HouseView v-if="houseItem !== false"
                       :item="houseItem"
                     :customers="customers"
                       :on-updated="onHouseItemUpdated"
                       :on-close="onHouseItemClosed"
                       :on-deleted="onHouseItemDeleted"/>
        </div>
      </div>
<!--      <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="airHouseItem !== false" @click="airHouseItem = false">-->
<!--        <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1500px; height: calc(100% - 20px); transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">-->

          <air-house-view
            v-if="airHouseItem !== false"
            :item="airHouseItem"
            :manifest="item.manifest"
            :request="item"
            :on-updated="onHouseItemUpdated"
            :on-close="onHouseItemClosed"
            :on-deleted="onHouseItemDeleted"/>

<!--        </div>-->
<!--      </div>-->
      <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="packingInvoiceItem != false" @click="packingInvoiceItem = false">
        <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1500px; height: 90%; transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">
          <packing-invoice-view
            :item="packingInvoiceItem"
            :request="item"
            :on-close="closePackingInvoiceItem"
            :on-updated="onPackingInvoiceItemUpdated"
            :on-deleted="onPackingInvoiceItemDeleted"/>

        </div>
      </div>
      <email-form v-if="emailItem !== false"
                  :item="emailItem.item"
                  :documents="emailItem.documents"
                  :on-close="closeEmailItem">

      </email-form>

      <template v-if="pdfItem !== false">
        <transition name="slideup">
          <pdf-viewer
            :item="pdfItem"
            :on-close="closePdfViewer">

          </pdf-viewer>
        </transition>
      </template>
    </div>

</template>

<script>
import {
  createNewJob,
  deleteJobLinker,
  deleteRequest,
  getItemTypeList,
  getParkingValues,
  getRequestPDF,
  getShippingMode,
  getStaff,
  getStateList,
  requestMethodList,
  sendEmailLinkToCustomer,
  sendEmailToCustomer,
  updateJobLinker,
  updateRequest,
  downloadExcel,
  generateRequestSurveyForm,
  getPackingInvoice,
  createNewPackingInvoice,
  updatePackingInvoice,
  generatePerformanceReportPDF, getPackingListExcel
} from "../api/request";
  import {
    createNewGoodItem,
    deleteGood,
    getGood,
    getGoods,
    getGoodSizeList,
    getGoodsTemplates,
    updateGood
  } from "../api/goods";
import {generateOrderNumber, millisToDate, millisToReadable, setPdfView, showDialog} from "../api/utils";
  import {createNewDocument, deleteDocument, getDocuments, updateDocument} from "../api/documents";
  import firebase from "firebase/app";
  import moment from 'moment';
  import {getAvailableManifests} from "../api/manifests";
  import InvoiceView from "./InvoiceView";
  import {createNewInvoice, createNewInvoiceItem, deleteInvoice, getInvoice, updateInvoice} from "../api/invoices";
  import {createHouse, getHouse, updateHouse} from "../api/houses";
  import HouseView from "./HouseView";
  import AirHouseView from "./AirHouseView.vue";
  import PackingInvoiceView from "./PackingInvoiceView.vue";
  import FileDownload from "js-file-download";
  import EmailForm from "./EmailForm";
  import EventBus from "../api/event-bus";
  import PdfViewer from "./PdfViewer.vue";
    export default {
      name: "RequestItemView",
      props: {
        item: {
          type:Object,
          default: function(){return null;}
        },
        onUpdated: {
          type:Function,
          default:null,
        },
        onClose: {
          type: Function,
          default:null,
        },
        onClone: {
          type: Function,
          default:null,
        },
        onDeleted: {
          type: Function,
          default:null,
        },
        customers: {
          type: Array,
          default: () => [],
        }
      },
      data() {
        return {
          preparationList:[],
          locationList:[],
          stateList: getStateList(),
          parkingValues:getParkingValues(),
          goodSizeList:getGoodSizeList(),
          emailItem:false,
          documents:[],
          staffList:[],
          images:[],
          editGoodItem: false,
          goodExamples:[],
          sizeList:getGoodSizeList(),
          locationItem:false,
          itemTypeList: getItemTypeList(),
          contractorNameInput:'',
          vehicleInput:'',
          manifestCandidates:null,
          requestMethods:requestMethodList(),
          shippingModes:getShippingMode(),
          quotation:false,
          invoice:false,
          invoiceItem: false,
          houseItem: false,
          airHouseItem: false,
          packingInvoiceItem: false,
          pdfItem:false,
        }
      },
      components: {
        InvoiceView,
        HouseView,
        AirHouseView,
        PackingInvoiceView,
        EmailForm,
        PdfViewer,
      },
      created() {
        console.log("ItemView")
        console.log(this.item);
        console.log(this.customers);

      },
      mounted() {
        this.getLocationList();
        this.getPreparationItemList();
        this.getStaffList();
        this.getGoodsSelectionList();
      },
      watch: {

      },
      beforeDestroy() {
      },
      destroyed() {
      },
      methods:{
        getDateTime: millisToReadable,
        dummy: function() {},
        downloadPDF: function() {
          let self = this;
          const FileDownload = require('js-file-download');
          getRequestPDF(this.item.id)
            .then(function(response) {
              FileDownload(response.data, "MOVE-JOB-" + self.item.id + ".pdf");
            })
            .catch(function(err) {

            })
        },

        getGoodsSelectionList: function() {
          let self = this;
          getGoodsTemplates("item_example")
            .then(function(data) {
              if(data.success == true) {
                self.$data.goodExamples = data.item;
              }
            })
            .catch(function(err) {

            })
        },

        getPreparationItemList: function() {
          let self = this;
          getGoods('preparation_example')
            .then(function(data) {
              if(data.success == true) {
                self.$data.preparationList = data.item;
              }
            })
        },
        closeItem: function() {
          if(this.onClose !== null) {
            this.onClose();
            return;
          }

          this.item = false;
        },
        cloneItem: function() {
          if(this.onClone !== null) {
            this.onClone(this.item);
          } else {
            showDialog("복사 불가능합니다.");
          }
        },
        createItem: function() {
          let self = this;
          updateRequest(this.item)
            .then(function(data) {
              if(data.success == true) {
                // for(let i = 0 ; i < self.$data.items.length ; i++) {
                //   if(self.$data.items[i].id == data.item.id) {
                //     self.$data.items.splice(i, 1, data.item);
                //     break;
                //   }
                // }
                // self.openItem(data.item.id);
                if(self.onUpdated !== null) {
                  self.onUpdated(data.item);
                }
                if(self.onClose !== null) {
                  self.onClose();
                }
              }


            })
            .catch(function(err){
              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }
            })
        },
        deleteItem: function() {
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: '현재 이사 아이템을 삭제하시겠습니까?',
            buttons: [
              {
                title: '아니요',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: '지우기',
                handler: () => {
                  self.$modal.hide('dialog');

                  self.deleteItemConfirmed();
                }
              },

            ]

          });
        },
        deleteItemConfirmed: function() {
          let self = this;
          deleteRequest(this.item.id)
          .then(function(data) {
            if(data.success === true) {
              if(self.onDeleted != null) {
                self.onDeleted(self.item);
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += " (" + err.response + ")";
            }
            showDialog(msg, "ERROR");
          })
        },
        onCustomerChanged: function() {
          this.item.companyName = '';
          for(let i = 0 ; i < this.customers.length ; i++) {
            if(this.customers[i].id === this.item.customerId) {
              this.item.companyName = this.customers[i].title;
            }
          }
          this.updateItem();
        },
        completeItem: function() {
          this.item.state = 100;
          let self = this;
          updateRequest(this.item)
          .then(function(data) {
            if(data.success == true) {

              if(self.onUpdated !== null) {
                self.onUpdated(data.item);
              }

              if(self.onClose !== null) {
                self.onClose();
              }

            } else{
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            showDialog(err, "ERROR");
          })
        },
        updateItem: function(close = false) {
          let self = this;
          if(this.item.id == 0) {
            return;
          }
          console.log("update item");
          if(this.item.cbmFloat === null) {
            this.item.cbm = 0;
          } else {
            this.item.cbm = Math.round(this.item.cbmFloat * 100);
          }
          updateRequest(this.item)
            .then(function(data) {
              if(data.success == true) {
                // for(let i = 0 ; i < self.$data.items.length ; i++) {
                //   if(self.$data.items[i].id == data.item.id) {
                //     self.$data.items.splice(i, 1, data.item);
                //     break;
                //   }
                // }
                // self.openItem(data.item.id);
                if(self.onUpdated !== null) {
                  self.onUpdated(data.item);
                }

                if(close === true) {
                  if(self.onClose !== null) {
                    self.onClose();
                  }
                }
              }


            })
            .catch(function(err){
              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }
            })
        },
        openLocationItems: function(location) {
          this.$data.locationItem = {
            location: location,
            newItemTitle:'',
            list:[],
          }
        },
        addLocationGood: function(candidate) {
          let newGoodItem = createNewGoodItem(this.item.id, 'item');
          newGoodItem.requestId = this.item.id;
          newGoodItem.location = this.$data.locationItem.location.title;
          newGoodItem.title = candidate;
          newGoodItem.size = 'M';
          let self = this;
          updateGood(newGoodItem)
            .then(function(data) {
              if(data.success === true) {
                let found = false;
                for(let i = 0 ; i < self.item.items.length ; i++) {
                  if(self.item.items[i].id === data.item.id) {
                    self.item.items.splice(i, 1, data.item);
                    found = true;
                    break;
                  }
                }
                if(found === false) {
                  self.item.items.push(data.item);
                }
                self.sortGoods();
                setTimeout(self.scrollToBottomItemsList,100);
                self.$data.editGoodItem = data.item;
                // self.scrollToBottomItemsList();

              }
            })
        },
        scrollToBottomItemsList: function() {
          let container = document.getElementById("location-item-list-container");
          if(container !== null) {
            console.log("scroll to " + container.scrollHeight + "  " + container.clientHeight);
            // $('#location-item-list-container').animate({
            //   scrollTop: container.scrollHeight
            // }, 500);
            container.scrollTop = container.scrollHeight;
          } else {
            console.log("scroll view not found");
          }
        },
        addLocationGoodManually: function() {
          if(this.$data.locationItem.newItemTitle === null || this.$data.locationItem.newItemTitle === '' || this.$data.locationItem.newItemTitle.length === 0) {
            return;
          }
          let newGoodItem = createNewGoodItem(this.item.id, 'item');
          newGoodItem.requestId = this.item.id;
          newGoodItem.location = this.$data.locationItem.location.title;
          newGoodItem.title = this.$data.locationItem.newItemTitle;
          newGoodItem.size = 'M';

          this.$data.locationItem.newItemTitle = '';
          let self = this;
          updateGood(newGoodItem)
            .then(function(data) {
              if(data.success === true) {
                let found = false;
                for(let i = 0 ; i < self.item.items.length ; i++) {
                  if(self.item.items[i].id === data.item.id) {
                    self.item.items.splice(i, 1, data.item);
                    found = true;
                    break;
                  }
                }
                if(found === false) {
                  self.item.items.push(data.item);
                }
                self.sortGoods();
                self.scrollToBottomItemsList();
              }
            })
        },
        sortGoods: function() {
          if(this.$data.locationList == null || this.$data.locationList.length == 0) {
            return;
          }

          console.log("Location List");
          console.log(this.$data.locationList);
          let self = this;
          this.item.items.sort(function(a, b) {
            let aPos = 0;
            let bPos = 0;
            for(let i = 0 ; i < self.$data.locationList.length ; i++) {
              if(self.$data.locationList[i].title === a.location) {
                aPos = self.$data.locationList[i].pos;
                break;
              }
            }
            for(let i = 0 ; i < self.$data.locationList.length ; i++) {
              if(self.$data.locationList[i].title === b.location) {
                bPos = self.$data.locationList[i].pos;
                break;
              }
            }

            // console.log(a.title + " " + a.location + " pos " + aPos + " " + b.title + " " + b.location + " pos " + bPos);
            if(aPos < bPos) {
              return -1;
            } else if(aPos > bPos) {
              return 1;
            }
            return 0;

          })
        },
        addGoodItem: function() {
          let newGoodItem = createNewGoodItem(this.item.id, 'item');
          newGoodItem.requestId = this.item.id;
          // this.item.items.push(newGoodItem);
          this.$data.editGoodItem = newGoodItem;
        },
        deleteEditGoodItem: function(index) {
          if(this.$data.editGoodItem.id === 0) {
            this.$data.editGoodItem = false;
            return;
          }

          let self = this;
          deleteGood(this.$data.editGoodItem.id)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.item.items.length ; i++) {
                  if(data.item.id === self.item.items[i].id) {
                    self.item.items.splice(i, 1);
                    self.$data.editGoodItem = false;
                  }
                }

              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response !== undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        updateEditGoodItem: function() {

          let self = this;
          updateGood(this.$data.editGoodItem)
          .then(function(data) {
            if(data.success === true) {
              let found = false;
              for(let i = 0 ; i < self.item.items.length ; i++) {
                if(self.item.items[i].id === data.item.id) {
                  self.item.items.splice(i, 1, data.item);
                  found = true;
                  break;
                }
              }
              if(found === false) {
                self.item.items.push(data.item);
              }
              self.sortGoods();
              self.$data.editGoodItem = false;
            }
          })
        },
        openEditGoodItem: function(id) {
          let self = this;
          getGood(id)
          .then(function(data) {
            if(data.success === true) {
              self.$data.editGoodItem = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            console.log(msg);
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
              console.log(err.response);
            }
            showDialog(msg);
          })
        },
        updateLocationGoodItem: function(index) {

        },
        updateGoodItem: function(index) {

          let item = this.item.items[index];
          // if(item.title == null || item.title.length == 0) {
          //   return;
          // }
          let self = this;
          console.log("update good item");
          updateGood(item)
            .then(function(data) {
              console.log(data);
              if(data.success == true) {
                self.item.items.splice(index, 1, data.item);
                // self.sortGoods();
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        deleteGoodItem: function(index) {
          if(this.item.items[index].id == 0) {
            this.item.items.splice(index, 1);
            return;
          }

          let self = this;
          deleteGood(this.item.items[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.item.items.splice(index, 1);
              }
            })
            .catch(function(err) {

            })
        },
        addPreparationItem: function(parentId = 0) {
          let newGoodItem = createNewGoodItem(this.item.id, 'preparation');
          newGoodItem.requestId = this.item.id;
          newGoodItem.min = 1;
          newGoodItem.max = 100;
          newGoodItem.amount = 1;
          newGoodItem.parentId = parentId;
          this.item.preparations.push(newGoodItem);
        },
        updatePreparationItem: function(index) {

          let item = this.item.preparations[index];
          if(item.title == null || item.title.length == 0) {
            return;
          }
          let self = this;
          console.log("update good item");
          updateGood(item)
            .then(function(data) {
              console.log(data);
              if(data.success == true) {
                self.item.preparations.splice(index, 1, data.item);
              }
            })
            .catch(function(err) {

            })
        },
        deletePreparationItem: function(index) {
          if(this.item.preparations[index].id == 0) {
            this.item.preparations.splice(index, 1);
            return;
          }

          let self = this;
          deleteGood(this.item.preparations[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.item.preparations.splice(index, 1);
              }
            })
            .catch(function(err) {

            })
        },
        onClickPreparationList: function(item, parentId = 0) {
          let newGoodItem = createNewGoodItem(this.item.id, 'preparation');
          newGoodItem.requestId = this.item.id;
          newGoodItem.title = item.title;
          newGoodItem.min = item.min;
          newGoodItem.max = item.max;
          newGoodItem.gap = item.gap;
          newGoodItem.parentId = parentId;
          newGoodItem.amount = 1;
          let self = this;
          updateGood(newGoodItem)
            .then(function(data) {
              console.log(data);
              if(data.success == true) {
                self.item.preparations.push(data.item);
              }
            })
            .catch(function(err) {

            })
        },
        getPreparationItemCount: function(item) {
          let count = 0;
          for(let i = 0 ; i < this.item.preparations.length ; i++) {
            if(item.title === this.item.preparations[i].title) {
              count += this.item.preparations[i].amount;
            }
          }
          return count;
        },
        showPreparationItem: function(item) {
          return true;
          // for(let i = 0 ; i < this.item.preparations.length ; i++) {
          //   if(this.item.preparations[i].title == item.title) {
          //     return false;
          //   }
          // }
          // return true;
        },
        removeEmailDocItem: function(index) {
          this.$data.emailItem.documents.splice(index, 1);
        },
        addEmailDocItem: function(doc) {
          this.$data.emailItem.documents.push(JSON.parse(JSON.stringify(doc)));
        },
        closeEmailItem: function() {
          this.$data.emailItem = false;
        },
        sendEmailForm: function() {
          if(this.item.shippingMode !== 'SEA OUT' && this.item.shippingMode !== 'AIR IN' && this.item.shippingMode !== 'SEA IN') {
            showDialog("SEA OUT, AIR IN, SEA IN 만 이메일 발송이 가능합니다.");
            return;
          }
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: '고객에게 업데이트 이메일을 보내시겠습니까?',
            buttons: [
              {
                title: '아니요',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: '보내기',
                handler: () => {
                  self.$modal.hide('dialog');

                  self.sendEmailFormConfirmed();
                }
              },

            ]

          });
        },
        sendEmailFormConfirmed: function() {

          sendEmailLinkToCustomer(this.item.id)
            .then(function(data) {
              if(data.success == true) {
                showDialog("Sent");
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg);
            })
        },
        openEmailItem: function() {
          let item = {
            requestId:this.item.id,
            to:this.item.email,
            subject:'UKO Shipping #' + this.item.reference,
            body:'안녕하세요 UKO Shipping 입니다\n',
            documents:[],
          }
          this.$data.emailItem = {
            item:item,
            documents:[],
          };
          let orderNumber = generateOrderNumber();
          console.log(this.item.invoices);
          if(this.item.invoices !== null && this.item.invoices.length > 0 && this.item.invoices[0].url !== null && this.item.invoices[0].url.length > 0) {
            let doc = {
              title: 'Invoice-' + this.item.requester + '-' + (this.item.invoices[0].total/100.0).toFixed(2) + '-' + orderNumber,
              url: this.item.invoices[0].url,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.quotations !== null && this.item.quotations.length > 0 && this.item.quotations[0].url !== null && this.item.quotations[0].url.length > 0) {
            let doc = {
              title: 'Quotation-' + this.item.requester + '-' + (this.item.quotations[0].total/100.0).toFixed(2) + '-' + orderNumber,
              url: this.item.quotations[0].url,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.houses !== null && this.item.houses.length > 0 && this.item.houses[0].url !== null && this.item.houses[0].url.length > 0) {
            let doc = {
              title: 'HBL-' + this.item.houses[0].blNumber + '-' + this.item.houses[0].shipperTitle + '-' + orderNumber,
              url: this.item.houses[0].url,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.packingListDoc !== null && this.item.packingListDoc.length > 0) {
            let doc = {
              title: 'Packing-List-' + this.item.requester + '-' + this.item.hbNo + '-' + this.item.qty + '-' + orderNumber,
              url: this.item.packingListDoc,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.approvalLetter !== null && this.item.approvalLetter.length > 0) {
            let doc = {
              title: 'Approval-Letter-' + this.item.requester + '-' + this.item.hbNo + '-' + this.item.qty + '-' + orderNumber,
              url: this.item.approvalLetter,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.psid !== null && this.item.psid.length > 0) {
            let doc = {
              title: 'PS-ID-' + this.item.requester + '-' + this.item.hbNo + '-' + this.item.qty + '-' + orderNumber,
              url: this.item.psid,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.commercialInvoice !== null && this.item.commercialInvoice.length > 0) {
            let doc = {
              title: 'Commercial-Invoice-' + this.item.requester + '-' + this.item.hbNo + '-' + this.item.qty + '-' + orderNumber,
              url: this.item.commercialInvoice,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.tncAgreement !== null && this.item.tncAgreement.length > 0) {
            let doc = {
              title: 'TermsAndCondition-Agreement-' + this.item.requester + '-' + this.item.hbNo + '-' + this.item.qty + '-' + orderNumber,
              url: this.item.tncAgreement,
            }
            this.$data.emailItem.documents.push(doc);
          }
          if(this.item.reasonStatement !== null && this.item.reasonStatement.length > 0) {
            let doc = {
              title: 'Reason-Statement-' + this.item.requester + '-' + this.item.hbNo + '-' + this.item.qty + '-' + orderNumber,
              url: this.item.reasonStatement,
            }
            this.$data.emailItem.documents.push(doc);
          }

          let self = this;
          getDocuments(0, 'info_document')
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < data.item.length ; i++) {
                  self.$data.emailItem.documents.push(data.item[i]);
                }
                self.$data.documents = data.item;

              }
            })
            .catch(function(err) {

            })

        },
        sendEmailToCustomer: function() {
          let self = this;
          sendEmailToCustomer(this.$data.emailItem)
            .then(function(data) {
              self.$data.emailItem = false;
              showDialog(data.message);
            })
            .catch(function(err) {

            })
        },
        getLocationList: function() {
          let self = this;
          getGoods('location', 0, 'pos')
            .then(function(data) {
              if(data.success == true) {
                self.$data.locationList = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg);
            })
        },


        getStaffList: function() {
          let self = this;
          getStaff()
            .then(function(data) {
              if(data.success == true) {
                console.log("users");
                console.log(data.item);
                self.$data.staffList = data.item;
              } else {

              }
            })
            .catch(function(err) {

            })
        },
        isUserAssigned: function(user) {
          if(this.item.assignees.length > 0) {
            for(let i = 0 ; i < this.item.assignees.length ; i++) {
              if(this.item.assignees.userId === user.id) {
                return true;
              }
            }
          }
          return false;
        },
        assignStaff: function(user) {
          if(this.item.assignees.length > 0) {
            for(let i = 0 ; i < this.item.assignees.length ; i++) {
              if(this.item.assignees.userId === user.id) {
                showDialog("Already assigned");
                return;
              }
            }
          }
          let newItem = createNewJob(this.item.id, user);

          let self = this;
          updateJobLinker(newItem)
            .then(function(data) {
              if(data.success == true) {
                self.item.assignees.push(data.item);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        deleteContractor: function(index) {
          this.item.contractors.splice(index, 1);
        },
        contractorNameEntered: function() {
          if(this.$data.contractorNameInput !== null && this.$data.contractorNameInput.length > 0) {
            this.item.contractors.push(this.$data.contractorNameInput);
            this.$data.contractorNameInput = '';
          }
        },
        deleteVehicle: function(index) {
          this.item.vehicles.splice(index, 1);
        },
        vehicleEntered: function() {
          if(this.$data.vehicleInput !== null && this.$data.vehicleInput.length > 0) {
            this.item.vehicles.push(this.$data.vehicleInput);
            this.$data.vehicleInput = '';
          }
        },
        deleteAssignee: function(index) {
          if(this.item.assignees[index].id == 0) {
            this.item.assignees.splice(index, 1);
            return;
          }
          let self = this;
          deleteJobLinker(this.item.assignees[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.item.assignees.splice(index, 1);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },

        selectManifest: function(manifest = null) {
          if(manifest === null) {
            this.item.manifestId = 0;
            this.item.manifest = null;
          } else {
            this.item.manifestId = manifest.id;
            this.item.manifest = manifest;
          }
          this.updateItem();
        },
        getAvailableManifests: function() {
          // let date = millisToDate(new Date().getTime());
          let self = this;
          getAvailableManifests(0, 99)
          .then(function(data) {
            if(data.success === true) {
              self.$data.manifestCandidates = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        getImageThumbnailUrl: function(url) {
          if(url === null || url.length === 0) {
            return '';
          }

          let words = url.split('.');
          let fileExt = words[words.length -1];

          url = url.replace('.' + fileExt, '_300x300.' + fileExt);
          return url;
        },
        takePhotoToAdd: function(e) {
          const uploader = document.getElementById('uploader-add');
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name  =  moment(d).format('YYYYMMDD-hhmmss');
          let names = getFile.name.split('.');

          let path = 'house-' + this.item.id + '/goods/'  + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          EventBus.$emit("showLoading", true);
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;
            },
            function error(err){
              EventBus.$emit("showLoading", false);
              console.log(err);
            },
            function complete(){
              // EventBus.$emit("showLoading", false);
              console.log('complete upload');
              // self.$data.editGoodItem.imageUrl = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
              // self.updateEditGoodItem();

              setTimeout(function() {
                self.onRoomPhotoTaken('https://storage.googleapis.com/uko-projects.appspot.com/' + path);
              }, 2000);
            }
          );
        },
        onRoomPhotoTaken: function(imageUrl) {
          let newGoodItem = createNewGoodItem(this.item.id, 'item');
          newGoodItem.requestId = this.item.id;
          // newGoodItem.location = this.$data.locationItem.location.title;
          newGoodItem.imageUrl = imageUrl;
          // newGoodItem.title = this.$data.locationItem.newItemTitle;
          newGoodItem.size = 'M';

          // this.$data.locationItem.newItemTitle = '';
          let self = this;
          EventBus.$emit("showLoading", false);
          updateGood(newGoodItem)
            .then(function(data) {
              if(data.success === true) {
                let found = false;
                for(let i = 0 ; i < self.item.items.length ; i++) {
                  if(self.item.items[i].id === data.item.id) {
                    self.item.items.splice(i, 1, data.item);
                    found = true;
                    break;
                  }
                }
                if(found === false) {
                  self.item.items.push(data.item);
                }
                self.sortGoods();
                self.scrollToBottomItemsList();
              }
            })
        },
        imageSelected: function(e) {
          const uploader = document.getElementById('uploader');
          //get file
          console.log("File Btn Added");
          console.log(e);
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name  =  moment(d).format('YYYYMMDD-hhmmss');
          let names = getFile.name.split('.');

          let path = 'house-' + this.item.id + '/goods/' + this.$data.editGoodItem.requestId + "/"  + this.$data.editGoodItem.id + '-' + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;
            },
            function error(err){
              console.log(err);
            },
            function complete(){
              console.log('complete upload');
              self.$data.editGoodItem.imageUrl = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
              // self.updateEditGoodItem();
            }
          );
        },


        itemImageSelected: function(e, field, isList = true) {
          const uploader = document.getElementById('uploader-' + field);
          //get file
          console.log("File Btn Added");
          console.log(e);
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name  =  moment(d).format('YYYYMMDD-hhmmss');
          let names = getFile.name.split('.');

          let path = 'house-' + this.item.id + "/" + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;
            },
            function error(err){
              console.log(err);
            },
            function complete(){
              console.log('complete upload');
              if(isList) {
                self.item[field].push('https://storage.googleapis.com/uko-projects.appspot.com/' + path);
              } else {
                self.item[field] = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
              }
              self.updateItem();
              // self.updateEditGoodItem();
            }
          );
        },

        itemImageDocSelected: function(e) {
          const uploader = document.getElementById('uploader');
          //get file
          console.log("File Btn Added");
          console.log(e);
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name  =  moment(d).format('YYYYMMDD-hhmmss');
          let names = getFile.name.split('.');

          let path = 'house-' + this.item.id + "/"  + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;
            },
            function error(err){
              console.log(err);
            },
            function complete(){
              console.log('complete upload');
              let newDoc = createNewDocument(self.item.id, 'media');
              newDoc.url = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
              self.updateImageDocumentItem(newDoc);
              // self.updateEditGoodItem();
            }
          );
        },

        deleteImageDocumentItem: function(item) {
          let self = this;
          deleteDocument(item.id)
          .then(function(data) {
            if(data.success === true) {
              for(let i = 0 ; i < self.$data,item.images.length ; i++) {
                if(self.$data,item.images[i] === data.item.id) {
                  self.$data,item.images.splice(i, 1);
                  return;
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        updateImageDocumentItem: function(item) {
          let self = this;
          updateDocument(item)
          .then(function(data) {
            if(data.success === true) {
              for(let i = 0 ; i < self.$data,item.images.length ; i++) {
                if(self.item.images[i] === data.item.id) {
                  self.item.images.splice(i, 1, data.item);
                  return;
                }
              }
              self.item.images.push(data.item);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        docPicked: function(e, field) {
          const uploader = document.getElementById('uploader-' + field);
          //get file
          console.log("File Btn Added");
          console.log(e);
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name  =  this.item.requester + '-' + field + '-' + moment(d).format('YYYYMMDD-hhmmss');
          let names = getFile.name.split('.');

          let path = 'house-' + this.item.id + "/doc/" + field + '/'  + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;
            },
            function error(err){
              console.log(err);
            },
            function complete(){
              console.log('complete upload');
              self.item[field] = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;

              self.updateItem();
              // self.updateEditGoodItem();
            }
          );
        },
        closePackingInvoiceItem: function() {
          this.$data.packingInvoiceItem = false;
        },
        onPackingInvoiceItemUpdated: function(item) {
          this.item.packingInvoiceItem = item;
        },
        onPackingInvoiceItemDeleted: function() {
          this.item.packingInvoiceItem = null;
        },
        createPackingInvoiceItem: function() {
          let newItem = createNewPackingInvoice(this.item);
          let self = this;
          updatePackingInvoice(newItem)
            .then(function(data) {
              if(data.success === true) {
                self.item.packingInvoiceItem = data.item;
                self.$data.packingInvoiceItem = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }

              showDialog(err, "ERROR");
            })
        },
        openPackingInvoiceItem: function(item) {
          let self = this;
          getPackingInvoice(item.id)
            .then(function(data) {
              if(data.success === true) {
                self.$data.packingInvoiceItem = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }

              showDialog(err, "ERROR");
            })
        },
        openHouseItem: function(item) {
          let self = this;
          getHouse(item.id)
          .then(function(data) {
            if(data.success === true) {
              if(self.item.shippingMode === 'AIR OUT') {
                if(data.item.manifestId !== self.item.manifest.id) {
                  data.item.manifestId = self.item.manifest.id;
                }
                self.$data.airHouseItem = data.item;

              } else {
                self.$data.houseItem = data.item;
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response !== undefined) {
              console.log(err.response);
            }

            showDialog(err, "ERROR");
          })
        },
        createHouse: function() {
          if(this.item.manifest === null) {
            showDialog("Manifest가 먼저 지정이 되어야 합니다.", "ERROR");
            return;
          }
          if(this.item.customerId === 0) {
            showDialog("청구처를 먼저 선택해주세요");
          }
          let newItem = createHouse();

          newItem.manifestId = this.item.manifest.id;
          newItem.shipperTitle = this.item.requester;
          newItem.consigneeTitle = this.item.requester;
          // if(this.item.shippingMode === 'SEA IN' || this.item.shippingMode === 'AIR IN' ) {
          //   newItem.shipperAddress1 = this.item.addressFrom;
          //   newItem.shipperTel = this.item.phoneNumber;
          //   newItem.consigneeAddress1 = this.item.addressTo;
          //   newItem.consigneeTel = this.item.destinationTel;
          // } else {
          newItem.shipperAddress1 = this.item.addressFrom;
          newItem.shipperTel = this.item.phoneNumber;
          newItem.consigneeAddress1 = this.item.addressTo;
          newItem.consigneeTel = this.item.destinationTel;
          // }
          newItem.consigneeEmail = this.item.email;
          newItem.requestId = this.item.id;
          newItem.cbm = this.item.cbm;
          newItem.kg = this.item.kg;
          newItem.gw = newItem.kg;
          if(newItem.gw > 0) {
            newItem.gwFloat = newItem.kg / 100.0;
          }
          newItem.cw = newItem.kg;
          newItem.cwFloat = newItem.gwFloat;
          newItem.nop = this.item.qty;
          if(this.item.shippingMode === 'AIR OUT') {
            newITem.blNumber = this.item.reference;
          } else {
            newItem.blNumber = this.item.hbNo;
          }


          newItem.volume = this.item.volume;
          if(this.item.manifest !== null) {
            newItem.pol = this.item.manifest.portOfLoading;
            newItem.pod = this.item.manifest.portOfDischarge;
            newItem.vessel = this.item.manifest.vessel;
            newItem.sealNumber = this.item.manifest.sealNumber;
            newItem.containerNumber = this.item.manifest.containerNumber;
            newItem.containerSize = this.item.manifest.containerSize;
            newItem.mblNo = this.item.manifest.mblNo;



          }

          let self = this;
          updateHouse(newItem)
            .then(function(data) {
              if(data.success === true) {
                self.item.houses.unshift(data.item);
                if(self.item.shippingMode === 'AIR OUT') {
                  self.$data.airHouseItem = data.item;
                } else {
                  self.$data.houseItem = data.item;
                }


              } else {
                showDialog(data.message);
              }
            })
        },
        onHouseItemUpdated: function(item) {
          for(let i = 0 ; i < this.item.houses.length ; i++) {
            if(this.item.houses[i].id === item.id) {
              this.item.houses.splice(i, 1, item);
              break;
            }
          }



          // this.$data.houseItem = false;
        },
        onHouseItemClosed: function() {
          this.$data.houseItem = false;
          this.$data.airHouseItem = false;
        },
        onHouseItemDeleted: function(item) {
          let found = false;
          for(let i = 0 ; i < this.item.houses.length ; i++) {
            if(this.item.houses[i].id === item.id) {
              this.item.houses.splice(i, 1);
              found = true;
              break;
            }
          }


          this.$data.houseItem = false;
          this.$data.airHouseItem = false;
        },
        generatePerformanceReport: function() {

          let self = this;
          generatePerformanceReportPDF(this.item.id)
          .then(function(data) {

          })
          .catch(function(err) {
            let msg = err.response;

            showDialog(msg, "ERROR");

          })
        },





        openInvoiceItem: function(item) {
          let self = this;
          getInvoice(item.id)
          .then(function(data) {
            if(data.success === true) {
              self.$data.invoiceItem = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response !== undefined) {
              console.log(err.response);
            }

            showDialog(err, "ERROR");
          })
        },
        createInvoiceFromQuotation: function(quotation) {
          let newItem = JSON.parse(JSON.stringify(quotation));
          newItem.id = 0;
          newItem.type = 'invoice';
          newItem.shipper = newItem.expatriatesName;
          newItem.invoiceDate = '';
          newItem.invoiceNumber = '';
          newItem.dueDate = '';

          let self = this;
          updateInvoice(newItem)
            .then(function(data) {
              if(data.success === true) {
                if(data.item.type === 'invoice') {
                  self.item.invoices.unshift(data.item);
                  self.$data.invoiceItem = data.item;
                } else {
                  self.item.quotations.unshift(data.item);
                  self.$data.invoiceItem = data.item;
                }
              } else {
                showDialog(data.message);
              }
            })
        },
        onCreditMoneyChanged: function(index) {
          this.item.credits[index].amount = parseInt(parseFloat(this.item.credits[index].amountFloat)*100);
          this.item.credits[index].vat = parseInt(parseFloat(this.item.credits[index].vatFloat)*100);
          this.item.credits[index].totalFloat = parseFloat(this.item.credits[index].amountFloat) + parseFloat(this.item.credits[index].vatFloat)
          this.item.credits[index].total = this.item.credits[index].amount + this.item.credits[index].vat;
        },
        addCredit: function() {
          let credit = createNewInvoice(this.item.id, 'credit');
          credit.shipper = this.item.requester;
          credit.edit = true;
          credit.shippingMode = this.item.shippingMode;
          credit.blNo = this.item.hbNo;
          this.item.credits.push(credit);
        },
        deleteCredit: function(index) {
          if(this.item.credits[index].id === 0) {
            this.item.credits.splice(index, 1);
            return;
          }
          let self = this;
          deleteInvoice(this.item.credits[index].id)
          .then(function(data) {
            if(data.success === true) {
              self.item.credits.splice(index, 1);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        cancelCreditEdit: function(index) {
          let self = this;
          if(this.item.credits[index].id === 0) {
            this.item.credits.splice(index, 1);
            return;
          }
          getInvoice(this.item.credits[index].id)
          .then(function(data) {
            if(data.success === true) {
              self.item.credits.splice(index, 1, data.item);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        saveCredit: function(index) {
          console.log("saveCredit");
          console.log(this.item.credits[index]);
          if(this.item.credits[index].invoiceDate === null || this.item.credits[index].invoiceDate === "" || this.item.credits[index].invoiceDate === '0000-00-00') {
            showDialog("Credit 날짜를 선택해주세요");
            return;
          }

          for(let i = 0 ; i < this.customers.length ; i++) {
            if(this.customers[i].id === this.item.credits[index].customerId) {
              this.item.credits[index].invoiceTo = this.customers[i].title;
              this.item.credits[index].invoiceAddress = this.customers[i].address;
              this.item.credits[index].invoiceToEmail = this.customers[i].email;
              this.item.credits[index].invoiceToTel = this.customers[i].contact;

            }
          }
          this.item.credits[index].finalised = true;
          this.item.credits[index].paid = this.item.credits[index].total;
          let self = this;
          updateInvoice(this.item.credits[index])
          .then(function(data) {
            if(data.success === true) {
              self.item.credits.splice(index, 1, data.item);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        createInvoice: function(type) {
          console.log(this.item);
          console.log("create invoice " + this.item.customerId);
          if(type === 'invoice' && this.item.customerId === 0) {
            showDialog("청구처를 먼저 선택하세요");
            return;
          }

          if(type === 'invoice' && this.item.shippingMode === '') {
            showDialog("Shipping Mode를 선택해주세요");
            return;
          }

          if(type === 'invoice' && this.item.shippingMode !== 'DOMESTIC' && this.item.shippingMode !== 'EURO LAND' && (this.item.manifestId === 0 || this.item.manifest === null)) {
            showDialog("인보이스 발행을 위해서 Manifest를 먼저 설정해주세요");
            return;
          }
          let newItem = createNewInvoice(this.item.id, type);
          newItem.shipper = this.item.requester;
          newItem.shippingMode = this.item.shippingMode;
          if(this.item.shippingMode === 'AIR IN' || this.item.shippingMode === 'SEA IN') {
            newItem.residenceAddress = this.item.addressTo;
          } else {
            newItem.residenceAddress = this.item.addressFrom;
          }
          newItem.cbm = this.item.cbm;
          newItem.cbmFloat = this.item.cbmFloat;
          newItem.kg = this.item.kg;
          newItem.qty = this.item.qty;
          newItem.blNo = this.item.hbNo;

          for(let i = 0 ; i < this.customers.length ; i++) {
            if(this.customers[i].id === this.item.customerId) {
              newItem.invoiceTo = this.customers[i].title;
              newItem.invoiceAddress = this.customers[i].address;
              newItem.invoiceToEmail = this.customers[i].email;
              newItem.invoiceToTel = this.customers[i].contact;

            }
          }



          if(this.item.packingDate !== null) {
            newItem.packingDate = this.item.packingDate;
          }
          newItem.volume = this.item.volume;
          if(this.item.manifest !== null) {
            newItem.pol = this.item.manifest.portOfLoading;
            newItem.pod = this.item.manifest.portOfDischarge;
            newItem.etd = this.item.manifest.etd;
            newItem.eta = this.item.manifest.eta;
            newItem.vessel = this.item.manifest.vessel;
            newItem.containerNumber = this.item.manifest.containerNumber;
          }

          let self = this;
          updateInvoice(newItem)
          .then(function(data) {
            if(data.success === true) {
              if(data.item.type === 'invoice') {
                self.item.invoices.unshift(data.item);
                self.$data.invoiceItem = data.item;
              } else {
                self.item.quotations.unshift(data.item);
                self.$data.invoiceItem = data.item;
              }
            } else {
              showDialog(data.message);
            }
          })
        },
        onInvoiceItemUpdated: function(item) {
          let found = false;
          for(let i = 0 ; i < this.item.quotations.length ; i++) {
            if(this.item.quotations[i].id === item.id) {
              this.item.quotations.splice(i, 1, item);
              found = true;
              break;
            }
          }

          if(found === false) {
            for (let i = 0; i < this.item.invoices.length; i++) {
              if (this.item.invoices[i].id === item.id) {
                this.item.invoices.splice(i, 1, item);
                found = true;
                break;
              }
            }
          }

          this.$data.invoiceItem = false;
        },
        onInvoiceItemClosed: function() {
          this.$data.invoiceItem = false;
        },
        onInvoiceItemDeleted: function(item) {
          let found = false;
          for(let i = 0 ; i < this.item.quotations.length ; i++) {
            if(this.item.quotations[i].id === item.id) {
              this.item.quotations.splice(i, 1);
              found = true;
              break;
            }
          }

          if(found === false) {
            for (let i = 0; i < this.item.invoices.length; i++) {
              if (this.item.invoices[i].id === item.id) {
                this.item.invoices.splice(i, 1);
                found = true;
                break;
              }
            }
          }

          this.$data.invoiceItem = false;
        },
        downloadExcelFile: function(url, fileName) {
          const FileDownload = require('js-file-download');
          let self = this;
          window.open(url, "_blank");
          // fileName += '-' + new Date().getTime() + '.xlsx';
          // downloadExcel(url)
          // .then(function(response) {
          //   FileDownload(response.data, fileName);
          // })
          // .catch(function(err) {
          //
          // })
        },
        openSurveyForm: function() {
          console.log("open survey form");
          console.log(this.item);
          if(this.item.surveyForm === null || this.item.surveyForm.length === 0) {
            this.generateSurveyFormPDF();
            return;
          }
          let date = millisToDate(new Date(), '-');

          let emailForm = {
            to: '',
            subject:'SurveyForm-' + this.item.shippingMode + ' ' + this.item.requester + ' ' + date,
            body: '안녕하세요 UKO Shipping입니다.\n',
            documents:[{
              title:'SurveyForm-' + this.item.shippingMode + '-' + this.item.requester + '-' + generateOrderNumber(),
              url:this.item.surveyForm,
            }]
          }
          this.$data.pdfItem = {
            url: this.item.surveyForm,
            title:  this.item.requester + ' ' + this.item.hbNo + ' ' + ' #' + this.item.id,
            emailForm: emailForm,
            regenerateFn: this.generateSurveyFormPDF,
          }
        },
        generateSurveyFormPDF: function() {
          let self = this;

          console.log("generate survey form");
          generateRequestSurveyForm(this.item.id)
            .then(function(data) {
              if(data.success === true) {
                console.log("generated");
                console.log(data);

                self.item.surveyForm = data.item.surveyForm;

                if(self.item.surveyForm !== null && self.item.surveyForm.length > 0) {
                  self.openSurveyForm();
                }
                // self.openSurveyForm();
              } else {
                console.log(data.message);
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }
            })
        },
        generatePackingListEx: function() {
          console.log("generate packing list");
          let timestamp = new Date().getTime();
          console.log(this.item);
          let fileName = "PackingList-" + this.item.id + '-' + timestamp + '.xlsx';
          getPackingListExcel(this.item.id)
            .then(function(response) {
              FileDownload(response.data, fileName);
            })
            .catch(function(err) {
              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }
            })
        },
        openPackingListDoc: function() {
          console.log("open pdf");

          let date = millisToDate(new Date(), '-');

          let emailForm = {
            to: '',
            subject:'PackingList-' + this.item.shippingMode + ' ' + this.item.requester + ' ' + date,
            body: '안녕하세요 UKO Shipping입니다.\n',
            documents:[{
              title:'PackingList-' + this.item.shippingMode + '-' + this.item.requester + '-' + generateOrderNumber(),
              url:this.item.packingListDoc,
            }]
          }
          this.$data.pdfItem = {
            url: this.item.packingListDoc,
            title:  this.item.requester + ' ' + this.item.hbNo + ' ' + ' #' + this.item.id,
            emailForm: emailForm,
          }
        },
        closePdfViewer: function() {
          this.$data.pdfItem = false;
        },
        onDocumentUploadClicked: function(field) {
          this.$refs[field + 'File'].value = "";
          this.$refs[field + 'File'].click();
        },
        openDocument: function(url) {
          window.open(url, '_blank').focus();
        },
        onDocumentSelected: function(e, field) {

          // const uploader = document.getElementById('uploader-' + field);
          //get file
          console.log("File Btn Added");
          console.log(e);
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name  =  this.item.requester + '-' + field + '-' + moment(d).format('YYYYMMDD-hhmmss');
          let names = getFile.name.split('.');

          let path = 'house-' + this.item.id + "/doc/" + field + '/'  + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              // uploader.value = percentage;
            },
            function error(err){
              console.log(err);
            },
            function complete(){
              console.log('complete upload');
              self.item[field] = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;

              self.updateItem();
              // self.updateEditGoodItem();
            }
          );
        }
      }
    }
</script>

<style scoped>
.file-available {
  background: #24a6a4;
  color: white;
}
.open-btn {
  width: 100%;
  border: 1px solid #dadada;

  padding: 10px;
}
.upload-btn {
  margin-top: 10px;
  padding: 5px 10px;
  background: #dadada;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestItemView.vue